// Module
var code = "<div class=\"progress-bar-root\">\n  <div\n    id=\"progress-bar-wrapper\"\n    class=\"progress-bar-wrapper\"\n    v-show=\"enabled && progressBarVisible\"\n  ></div>\n  <div class=\"tooltip\" v-show=\"enabled && progressBarVisible\">\n    <span class=\"tooltiptext\">Downloading content...</span>\n  </div>\n</div>\n";
// Exports
export default code;